import api from './api';
import { auth } from '../firebase/config';

let lastTracked: { path: string; at: number } | null = null;

/**
 * Journalise une vue de page côté backend (collection `activity_logs`),
 * visible dans la session admin. Silencieux en cas d'erreur, dédoublonné sur 2 s.
 */
export const trackPageView = (path: string): void => {
  if (!auth.currentUser) return;
  const now = Date.now();
  if (lastTracked && lastTracked.path === path && now - lastTracked.at < 2000) return;
  lastTracked = { path, at: now };

  api
    .post('/activity/page', { path, referrer: document.referrer || undefined })
    .catch(() => {
      /* ne jamais gêner l'utilisateur */
    });
};
